import {
  RoundQuantityPicker,
  IRoundQuantityPickerProps,
} from "@faire/retailer-visitor-shared/components/RoundQuantityPicker";
import { IRoundQuantityPickerStateProps } from "@faire/retailer-visitor-shared/components/RoundQuantityPicker/UseRoundQuantityPickerState";
import React, { useCallback } from "react";

export const ProductTileRoundQuantityOptionPicker: React.FC<
  IRoundQuantityPickerProps & IRoundQuantityPickerStateProps
> = (props) => {
  const [value, setValue] = React.useState(props.value);

  const prevPropValue = React.useRef<number>(props.value);

  // As we speed up the ATC action, there is a higher chance that an action has started before the previous action completed.
  // the pendingUpdatesQueue tracks the updates intiated on the FE that have not resolved yet. The update will be resolved when
  // FE receives an updated quantity from a BE response (ie props.value changes).
  const pendingUpdatesQueue = React.useRef<number[]>([]);
  const validateValueAgainstPendingUpdatesQueue = useCallback(
    (newValue: number) => {
      // mulitple ATC clicks can be batched when hitting the BE and receiving a response, so we will look for the first occurence of the updated quantity
      const firstOccurenceIndex = pendingUpdatesQueue.current.findIndex(
        (pendingValue) => pendingValue === newValue
      );
      // if the updated quantity is not pending, the action was initiated from somewhere else, like the brand sidecart.
      if (firstOccurenceIndex === -1) {
        setValue(newValue);
        pendingUpdatesQueue.current = [];
      } else {
        pendingUpdatesQueue.current =
          pendingUpdatesQueue.current.slice(firstOccurenceIndex);
      }
    },
    []
  );

  if (props.value !== prevPropValue.current) {
    validateValueAgainstPendingUpdatesQueue(props.value);
    prevPropValue.current = props.value;
  }

  const onValueChange = (newValue: number) => {
    setValue(newValue);
    pendingUpdatesQueue.current.push(newValue);
    if (
      (props.maxValue && props.maxValue !== 0 && newValue <= props.maxValue) ||
      props.maxValue === undefined
    ) {
      props.onChange(newValue);
    }
  };

  return (
    <RoundQuantityPicker
      {...props}
      value={props.isMultiOption ? props.value : value}
      onChange={onValueChange}
    />
  );
};
